<div [hidden]="(!isConsumerCurriculum && filterValue == 'ungraded' && question.PointsEarned >= 0) || (isConsumerCurriculum && question.PointsAvailable == 0)">
  <mat-expansion-panel [expanded]="isConsumerCurriculum ? filterValue != 'ungraded' : true">
    <mat-expansion-panel-header>
      <mat-panel-title class="panel-title" fxLayout="row">
        
        <div class=question-title>
          
          <i class="far fa-check-circle correct-icon" *ngIf="correct"></i>
          <i class="far fa-times-circle incorrect-icon" *ngIf="!correct"></i>
          {{ question.QuestionTitle }}

        </div>
        
        <div class="points-status">
          [ {{ (question.PointsEarned == null ? '0' : question.PointsEarned) + ' / ' + question.PointsAvailable }} ]
        </div>

      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="question-text" [innerHTML]="question.QuestionText | safeHtml"></div>

    <div class="panel-body" fxLayout="row">

      <app-question-grading 
        [pointsEarned]="question.PointsEarned" 
        [pointsAvailable]="question.PointsAvailable"
        [questionType]="3" 
        [question]="question"
        [isConsumerCurriculum]="isConsumerCurriculum"
        [correct]="correct"
        (gradeStatusChanges)="gradeStatusChanged($event)"
        (partialCreditChanges)="partialCreditChanged($event)">
      </app-question-grading>

      <div class="response-container" [formGroup]="responseFormGroup">
        <mat-radio-group *ngIf="question.QuestionTypeEnumValue === 2" formControlName="studentResponse" fxLayout="column">
          <mat-radio-button [ngClass]="{'bg-green': question.AvailableResponses[0].Response == 'true'}" value="true">True</mat-radio-button>
          <mat-radio-button [ngClass]="{'bg-green': question.AvailableResponses[0].Response == 'false'}" value="false">False</mat-radio-button>
        </mat-radio-group>

        <mat-radio-group *ngIf="question.QuestionTypeEnumValue === 3" formControlName="studentResponse" fxLayout="column">
            <mat-radio-button
              *ngFor="let answer of question.AvailableResponses; let i = index"
              [ngClass]="{'bg-green': answer.IsCorrect == true}" 
              [value]="i"
            >
              <p [innerHTML]="answer.Response | safeHtml"></p>
            </mat-radio-button> 
        </mat-radio-group>
      </div>
     
      <div *ngIf="question.StudentResponse.length > 1" style="margin:10px">
        This student selected more than one answer. The chosen options were: 
          <div *ngFor="let response of question.StudentResponse">
           {{question.AvailableResponses[response].Response}} 
          </div>
      </div>

    </div>

    <div class="question-standard-title" *ngIf="question.StandardsCovered[0] != ''">
      Standards Covered:
    </div>
    <div class="question-standards" *ngFor="let standard of question.StandardsCovered">
      {{standard}}
    </div>

  </mat-expansion-panel>
</div>
